import { lazy } from 'react'
// import RootPage from '@cp/rootPage'
const Login = lazy(() => import('../pages/login'))
const Welfare = lazy(() => import('../pages/welfare'))
const Home = lazy(() => import('../components/home'))
const BookInfo = lazy(() => import('../components/bookInfo'))
const BookList = lazy(() => import('../pages/bookList'))
const CreateBook = lazy(() => import('../pages/createBook'))
const BookSet = lazy(() => import('../pages/bookSet'))
const BookContent = lazy(() => import('../pages/bookContent'))
const BookDrafts = lazy(() => import('../pages/bookDrafts'))
const Payment = lazy(() => import('../pages/payment'))
const BookFee = lazy(() => import('../pages/bookFee'))
const BookFeeDetail = lazy(() => import('../pages/bookFeeDetail'))
const UserInfo = lazy(() => import('../pages/userInfo'))
const HomeWelfare = lazy(() => import('../pages/homeWelfare'))
const MessageNotice = lazy(() => import('../pages/messageNotice'))
const Publish = lazy(() => import('../pages/publish'))
const SetPassword = lazy(() => import('../pages/setPassword'))
const applyAuthor = lazy(() => import('../pages/applyAuthor'))
const ResetPassword = lazy(() => import('../pages/resetPassword'))
const ShieldList = lazy(() => import('../pages/shieldList'))
const WechatLogin = lazy(() => import('../pages/wechatLogin'))
const PhoneBind = lazy(() => import('../pages/phoneBind'))
const Unbind = lazy(() => import('../pages/unbind'))
const BindAuthor = lazy(() => import('../pages/bindAuthor'))
const SuggestFeedback = lazy(() => import('../pages/suggestFeedback'))
const routes = [
  {
    path: '/home',
    component: Home,
    children: [
      {
        path: '/home/booklist',
        component: BookList
      },
      {
        path: '/home/createbook',
        component: CreateBook
      },
      {
        path: '/home/payment',
        component: Payment
      },
      {
        path: '/home/fee',
        component: BookFee
      },
      {
        path: '/home/feeDetail/:bookId',
        component: BookFeeDetail
      },
      {
        path: '/home/userInfo',
        component: UserInfo
      },
      {
        path: '/home/suggestFeedback',
        component: SuggestFeedback
      },
      {
        path: '/home/messageNotice',
        component: MessageNotice
      },
      // 为什么有2个福利页面呢? 是因为登录和非登录的作家福利的头部是不一样的
      {
        path: '/home/welfare',
        component: HomeWelfare,
        exact: true
      },
      {
        path: '/home/bookInfo/:bookId',
        component: BookInfo,
        children: [
          {
            path: '/home/bookInfo/:bookId/bookSet',
            component: BookSet
          },
          {
            path: '/home/bookInfo/:bookId/bookContent',
            component: BookContent
          },
          {
            path: '/home/bookInfo/:bookId/bookDrafts',
            component: BookDrafts
          },
          {
            path: '/home/bookInfo/:bookId/shieldList',
            component: ShieldList
          }
        ]
      },
      {
        path: '/home/applyAuthor',
        component: applyAuthor,
        exact: true
      }
    ]
  },
  {
    path: '/',
    component: Login,
    exact: true
  },
  {
    path: '/welfare',
    component: Welfare,
    exact: true
  },
  {
    path: '/publish/:bookId',
    component: Publish,
    exact: true
  },
  {
    path: '/setPassword',
    component: SetPassword,
    exact: true
  },
  {
    path: '/resetPassword',
    component: ResetPassword,
    exact: true
  },
  {
    path: '/wechatLogin',
    component: WechatLogin,
    exact: true
  },
  {
    path: '/phoneBind',
    component: PhoneBind,
    exact: true
  },
  {
    path: '/unbind/:type', // wechat 和 qq
    component: Unbind,
    exact: true
  },
  {
    path: '/bindAuthor/:type', // wechat 和 qq
    component: BindAuthor,
    exact: true
  },
]

export default routes
